module.exports = __webpack_public_path__ + "static/media/factory12.38c149f9.webp";